const dedupeObjectArray = function removeDuplicateObjectsFromArray(objectArray, attribute) {
  const attributeValues = [];

  return objectArray.filter((entity) => {
    if (!attributeValues.includes(entity[attribute])) {
      attributeValues.push(entity[attribute]);
      return entity;
    }

    return false;
  });
};

export default dedupeObjectArray;
